/* eslint-disable camelcase */
import common_fr from "./fr/common.json";
import common_en from "./en/common.json";
import common_hu from "./hu/common.json";
import common_es from "./es/common.json";
import common_ar from "./ar/common.json";
import common_cz from "./cz/common.json";
import common_ru from "./ru/common.json";
import common_zh from "./zh/common.json";

//import errors_fr from "./fr/errors.json";
//import errors_en from "./en/errors.json";
//import errors_hu from "./hu/errors.json";

export default {
  en: {
    common: common_en,
    //errors: errors_en,
  },
  es: {
    common: common_es,
    //errors: errors_es,
  },
  fr: {
    common: common_fr,
    //errors: errors_fr,
  },
  hu: {
    common: common_hu,
    //errors: errors_hu,
  },
  ar: {
    common: common_ar,
    //errors: errors_ar,
  },
  cz: {
    common: common_cz,
    //errors: errors_cz,
  },
  ru: {
    common: common_ru,
  },
  zh: {
    common: common_zh,
  },
};
